import React, { useEffect, useState } from 'react';
import { CheckCircle, Clock, Mail, ArrowRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_autoposter-32/artifacts/j0h273d6_auto.png";

const ThankYouPage = () => {
  const [onboardingData, setOnboardingData] = useState(null);

  useEffect(() => {
    // Retrieve onboarding data from localStorage
    const data = localStorage.getItem('autopostr_onboarding');
    if (data) {
      setOnboardingData(JSON.parse(data));
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6 py-16">
      <div className="max-w-2xl mx-auto text-center">
        {/* Logo */}
        <img 
          src={LOGO_URL} 
          alt="AutoPostr" 
          className="h-16 md:h-20 w-auto mx-auto mb-8"
        />

        {/* Success Icon */}
        <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-emerald-500/20 flex items-center justify-center">
          <CheckCircle size={40} className="text-emerald-500" />
        </div>

        {/* Main Message */}
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Thank you for joining AutoPostr!
        </h1>

        <p className="text-lg text-white/70 mb-8 leading-relaxed">
          Our team is now reviewing your setup request to ensure everything is tailored precisely to your goals.
        </p>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
          <div className="bg-[#141414] border border-white/10 rounded-2xl p-6 text-left">
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mb-4">
              <Clock size={20} className="text-emerald-400" />
            </div>
            <h3 className="text-white font-semibold mb-2">Processing Time</h3>
            <p className="text-white/60 text-sm">
              This usually takes <span className="text-white font-medium">1-3 business days</span> but not more.
            </p>
          </div>

          <div className="bg-[#141414] border border-white/10 rounded-2xl p-6 text-left">
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mb-4">
              <Mail size={20} className="text-emerald-400" />
            </div>
            <h3 className="text-white font-semibold mb-2">Check Your Inbox</h3>
            <p className="text-white/60 text-sm">
              You'll receive a <span className="text-white font-medium">personalised onboarding email</span> with next steps and access details.
            </p>
          </div>
        </div>

        {/* What's Next */}
        <div className="bg-[#141414] border border-white/10 rounded-2xl p-6 mb-10 text-left">
          <h3 className="text-white font-semibold mb-4">What we're preparing for you:</h3>
          <ul className="space-y-3">
            {[
              'Your posting schedule',
              'Content strategy based on your preferences',
              'Automation settings tailored to your goals',
              'Platform-safe posting configuration'
            ].map((item, index) => (
              <li key={index} className="flex items-center gap-3 text-white/70">
                <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
                  <CheckCircle size={12} className="text-emerald-500" />
                </div>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Plan Info */}
        {onboardingData && (
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8">
            <span className="text-sm text-white/60">Your plan:</span>
            <span className="text-sm font-medium text-emerald-400">{onboardingData.plan}</span>
          </div>
        )}

        {/* Back to Home */}
        <div>
          <a 
            href="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-black font-semibold hover:bg-white/90 transition-all duration-200"
          >
            Back to Home
            <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
